"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderConteudoMenuSanduicheFragment = void 0;
var contextos_frontend_1 = require("@aura/contextos-frontend");
var icons_1 = require("@lift/assets/dist/assets/globals/icons");
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var LftLogotipo_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftLogotipo"));
var react_1 = __importDefault(require("react"));
var tags_ga_1 = require("../../../../utils/tags-ga");
var line_divider_1 = require("../../../line-divider");
var header_conteudo_menu_sanduiche_styles_1 = require("./header-conteudo-menu-sanduiche.styles");
var HeaderConteudoMenuSanduicheFragment = function (_a) {
    var onClick = _a.onClick;
    var _b = (0, contextos_frontend_1.useConfig)(), brand = _b.brand, domain = _b.domain;
    var focarElementoHtml = function (idElemento) {
        var elemento = document.getElementById(idElemento);
        elemento === null || elemento === void 0 ? void 0 : elemento.focus();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(header_conteudo_menu_sanduiche_styles_1.CabecalhoStyled, null,
            react_1.default.createElement(header_conteudo_menu_sanduiche_styles_1.LogoWrapper, null,
                react_1.default.createElement(LftLogotipo_1.default, { alt: "Logotipo da institui\u00E7\u00E3o de ensino" })),
            react_1.default.createElement(tags_ga_1.TagsGa, { category: ['aura', brand, domain], action: ['clique', 'fechar-menu'], label: ['clique', 'fechar-menu'], eventType: "clique" },
                react_1.default.createElement(header_conteudo_menu_sanduiche_styles_1.BotaoFecharStyled, { onClick: function () {
                        focarElementoHtml('abrir-menu-sanduiche');
                        onClick();
                    }, "aria-label": "Fechar menu", "data-testid": "botao-fechar-menu" },
                    react_1.default.createElement(LftIconBase_1.default, { icon: icons_1.X, size: "md" })))),
        react_1.default.createElement(line_divider_1.LineDividerHor, { margin: '0' })));
};
exports.HeaderConteudoMenuSanduicheFragment = HeaderConteudoMenuSanduicheFragment;
